import { OrderStatus } from "@/features/order/domain/enums/OrderStatus";
import { OrderStreamFilterEntity } from "../../domain/entities/OrderStreamFilterEntity";
import { mapEntityProperties } from "@/utils/mapEntityProperties";
import type { RegionMiniEntity } from "@/features/region/domain/entities/RegionMiniEntity";

export class OrderStreamFilterModel extends OrderStreamFilterEntity {
  regionIds!: number[];
  fetchAll: boolean = true;
  orderStatuses: OrderStatus[] = [];
  branchId?: number;
  trackingPanelUserId?: string; 
  userId?: string;

  constructor(dataDto: OrderStreamFilterEntity) {
    super();
    const transformedData = {
      ...dataDto,
      fetchAll: dataDto.fetchAll !== undefined ? dataDto.fetchAll : !dataDto.orderStatuses?.length,
      orderStatuses: !dataDto.orderStatuses?.length 
        ? Object.values(OrderStatus)
        : dataDto.orderStatuses,
      regions: dataDto.regions || [] as RegionMiniEntity[]
    };

    mapEntityProperties<OrderStreamFilterModel>(this, transformedData, {
      exclude: ['regions', 'user', 'branch', 'trackingPanelUser'],
      map: {
        regionIds: transformedData.regions?.map(region => region.id!) || [],
        userId: transformedData.user?.id || undefined,
        branchId: transformedData.branch?.id || undefined,
        trackingPanelUserId: transformedData.trackingPanelUser?.id || undefined
      }
    });
  }
}